export class Picture
{
	pictureId: number;
	pictureDate: Date;
	createDate: Date;
	url: string;
	caption: string;
	shortTermRentalId: number;
}
